
import { IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';

export class CharityDto extends BaseDto {

    @IsString()
    title: string;

    @IsString()
    description: string;

    @IsString()
    @IsOptional()
    photoURL?: string;
}
